export default __webpack_public_path__ + "static/tc-0005ced687094d45d07c296bfd0787d2.svg";